var uAjax = "/index.cfm/customer/ajax/contact";

$(function()
{
	if(bContactFormRecaptcha)
	{
		disableBtn();
	}

	$('#btnSend').click(function(){
		var frmContact = $('#frmContact');
		validateContact(frmContact);
		return false;
	});
	initDropzone();
});

function validateContact(frmContact)
{
	// Clear previous errors
	clearErrors();

	// Validate form
	var bValid = validateForm(frmContact);

	if(bValid)
	{
		disableBtn();

		var sParams = '&edtfirstname=' + encodeURIComponent($('#inputFirstName').val())
		+ '&edtlastname=' + encodeURIComponent($('#inputLastName').val())
		+ '&edtEmail=' + encodeURIComponent($('#inputEmail').val())
		+ '&edtPhoneNum=' + encodeURIComponent($('#inputPhoneNum').val())
		+ '&edtQuestion=' + encodeURIComponent($('#inputQuestionType').val())
		+ '&edtOrder=' + encodeURIComponent($('#inputOrder').val())
		+ '&comment=' + encodeURIComponent($('#inputComment').val())
		+ '&vatNumber=' + encodeURIComponent($('#inputVatNumber').val())
		+ '&requestType=' + encodeURIComponent($('#inputRequestType').val())
		+ '&inStock=' + encodeURIComponent($('#inputinStock').val())
		+ '&image=' + encodeURIComponent((typeof $('#inputFilename').val() !== "undefined") ? $('#inputFilename').val() : "");
		

		if(bContactFormRecaptcha)
		{
			sParams += '&g-recaptcha-response=' + grecaptcha.getResponse();
		}

		$(document).trigger("logCustomEvent",['Contact','Send',$('#inputQuestionType').val()]);
		var oCall = callAjax("contact", sParams, "post");

		// process feedback
		oCall.success(function(oData)
		{
			if(oData.errorType == '')
			{
				// Register successful
				$('#frmContact > .fieldset').hide(200);
				$('#frmContact').append('<p class="questionSuccess">'+tQuestionSent+'</p>');

				$(document).trigger("contact");
			}
			else if(oData.errorType == 'recaptcha')
			{
				// show error message
				enableBtn();
			}
			else
			{
				// show error message
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
				enableBtn();
			}
		});
	}
}

function enableBtn()
{
	$(el('btnSend')).prop('disabled',false);
}
function disableBtn()
{
	$(el('btnSend')).prop('disabled',true);
}


function initDropzone()
{
	if($('.uploadContainer').length)
	{
		var oUploadContainer = $('.uploadContainer');
		var oInputFilename    = oUploadContainer.parents('.control-group').find('.inputFilename');
		var oImageUpload     = oUploadContainer.find('.imageUpload');
		var oUploadLoader    = oUploadContainer.find('.uploadLoader');
		var oUploadResult    = oUploadContainer.find('.uploadResult');

		// Dropzone
		if(!oImageUpload.hasClass('dz-clickable'))
		{
			oImageUpload.dropzone({
				url: "/index.cfm/content/ajax/upload/content",
				clickable: true,
				maxFilesize: 2,
				error: function(file,error,xhr)
				{
					oImageUpload.toggleClass('hide');
					oUploadLoader.toggleClass('hide');
	
					// show error message
					inlineAlert('error', error, false, $('.uploadContainer'));
				},
				success: function(file,oData)
				{
					if(oData.errorType == '')
					{
						oInputFilename.val(sStaticContentURL + tenantId + '/content/' + encodeURIComponent(oData.fileName));
						oUploadLoader.toggleClass('hide');
						oUploadResult.find('.filename').text(oData.fileName);
						oUploadResult.toggleClass('hide');
					}
					else
					{
						oImageUpload.toggleClass('hide');
						oUploadLoader.toggleClass('hide');

						// show error message
						showAlert('error', oData.errorMessage, oData.errorUnhandled);
					}

				},
				addedfile: function()
				{
					oImageUpload.toggleClass('hide');
					oUploadLoader.toggleClass('hide');
				}
			});
		}

		$('.contact').on('click','.removeUpload', function()
		{
			oImageUpload.toggleClass('hide');
			oInputFilename.val('');
			oUploadResult.toggleClass('hide');
		});
	}
}
